import { useState, useEffect, useCallback } from 'react'
import { api, contactsApi } from '../api'
import { useApp } from '../AppContext'
import { Empty, Loading, FormGroup } from '../components/ui'

const fmtDate = d => d ? new Date(d).toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long' }) : '—'

export default function Rapports() {
    const { toast, isAdmin, user } = useApp()
    const [rapports, setRapports] = useState([])
    const [hebdo, setHebdo] = useState([])
    const [loading, setLoading] = useState(true)
    const [tab, setTab] = useState(isAdmin ? 'hebdo' : 'mes-rapports')
    const [modal, setModal] = useState(false)
    const [selected, setSelected] = useState(null)
    const [filterTech, setFilterTech] = useState('')
    const [filterDate, setFilterDate] = useState('')
    const [filterClient, setFilterClient] = useState('')
    const [clients, setClients] = useState([])
    const [techniciens, setTechniciens] = useState([])

    const load = useCallback(() => {
        setLoading(true)
        const calls = [api.get('/rapports')]
        if (isAdmin) calls.push(api.get('/rapports/hebdo'))
        Promise.all(calls)
            .then(([r, h]) => {
                setRapports(r.data || [])
                if (h) setHebdo(h.data || [])
            })
            .catch(e => toast(e.message, 'error'))
            .finally(() => setLoading(false))
    }, [isAdmin])

    useEffect(() => { load() }, [load])

    useEffect(() => {
        if (isAdmin) {
            api.get('/equipe').then(r => setTechniciens((r.data || []).filter(u => u.role === 'technicien'))).catch(() => { })
        }
    }, [isAdmin])

    useEffect(() => {
        if (isAdmin) {
            api.get('/equipe').then(r => setTechniciens((r.data || []).filter(u => u.role === 'technicien'))).catch(() => { })
            contactsApi.list({ per_page: 200 }).then(r => setClients(r.data || [])).catch(() => { })
        }
    }, [isAdmin])

    async function soumettre(id) {
        if (!confirm('Soumettre ce rapport ? Il ne pourra plus être modifié.')) return
        try { await api.put(`/rapports/${id}`, {}); toast('Rapport soumis', 'success'); load() }
        catch (e) { toast(e.message, 'error') }
    }

    const rapportsFiltres = rapports.filter(r => {
        if (filterTech && String(r.user_id) !== String(filterTech)) return false
        if (filterDate && r.date_rapport !== filterDate) return false
        if (filterClient && String(r.contact_id) !== String(filterClient)) return false
        return true
    })

    const hebdoFiltre = hebdo.filter(r => {
        if (filterTech && String(r.user_id) !== String(filterTech)) return false
        if (filterDate && r.date_rapport !== filterDate) return false
        if (filterClient && String(r.contact_id) !== String(filterClient)) return false
        return true
    })
    // Grouper le rapport hebdo par technicien
    const parTech = hebdoFiltre.reduce((acc, r) => {
        const key = r.technicien_nom || 'Inconnu'
        if (!acc[key]) acc[key] = []
        acc[key].push(r)
        return acc
    }, {})

    return (
        <div className="content">
            {/* Tabs */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <div className="tabs" style={{ marginBottom: 0, borderBottom: 'none' }}>
                    {!isAdmin && (
                        <div className={`tab${tab === 'mes-rapports' ? ' active' : ''}`} onClick={() => setTab('mes-rapports')}>
                            <i className="ti ti-report" style={{ marginRight: 5 }} />Mes rapports
                        </div>
                    )}
                    {isAdmin && (
                        <>
                            <div className={`tab${tab === 'hebdo' ? ' active' : ''}`} onClick={() => setTab('hebdo')}>
                                <i className="ti ti-calendar-week" style={{ marginRight: 5 }} />Rapport hebdomadaire
                            </div>
                            <div className={`tab${tab === 'tous' ? ' active' : ''}`} onClick={() => setTab('tous')}>
                                <i className="ti ti-list" style={{ marginRight: 5 }} />Tous les rapports
                            </div>
                            {tab === 'tous' && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                    {rapportsFiltres.length === 0
                                        ? <Empty icon="report-off" message="Aucun rapport" />
                                        : rapportsFiltres.map(r => (
                                            <div key={r.id} style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderLeft: `4px solid ${r.statut === 'soumis' ? 'var(--success)' : 'var(--warning)'}`, borderRadius: 'var(--radius)', padding: '14px 16px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                        <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f3e5f5', color: '#6a1b9a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 11 }}>
                                                            {(r.technicien_nom || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
                                                        </div>
                                                        <div>
                                                            <strong style={{ fontSize: 13 }}>{r.technicien_nom}</strong>
                                                            <div style={{ fontSize: 12, color: 'var(--text3)' }}>{fmtDate(r.date_rapport)}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        {r.contact_nom && <span style={{ fontSize: 12, color: 'var(--primary)' }}><i className="ti ti-building" style={{ marginRight: 3 }} />{r.contact_nom}</span>}
                                                        <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: r.statut === 'soumis' ? '#e8f5e9' : '#fff8e1', color: r.statut === 'soumis' ? '#2e7d32' : '#e65100' }}>
                                                            {r.statut === 'soumis' ? '✓ Soumis' : '✏ Brouillon'}
                                                        </span>
                                                    </div>
                                                </div>
                                                <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 4 }}>{r.contenu}</p>
                                                {r.interventions && <p style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 2 }}><strong>Interventions :</strong> {r.interventions}</p>}
                                                {r.problemes && <p style={{ fontSize: 12, color: 'var(--danger)' }}><strong>Problèmes :</strong> {r.problemes}</p>}
                                                {r.photos && JSON.parse(r.photos).length > 0 && (
                                                    <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                                                        {JSON.parse(r.photos).map((p, i) => (
                                                            <a key={i} href={window.location.origin + '/api/' + p} target="_blank" rel="noreferrer">
                                                                <img src={window.location.origin + '/api/' + p} alt="" style={{ width: 80, height: 60, objectFit: 'cover', borderRadius: 4, border: '1px solid var(--border)', cursor: 'pointer' }} />
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    }
                                </div>
                            )}
                        </>
                    )}
                </div>
                {!isAdmin && (
                    <button className="btn primary" onClick={() => setModal(true)}>
                        <i className="ti ti-plus" /> Rapport du jour
                    </button>
                )}
            </div>
            {isAdmin && (
                <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
                    <select className="form-control" style={{ width: 200 }} value={filterTech} onChange={e => setFilterTech(e.target.value)}>
                        <option value="">Tous les techniciens</option>
                        {techniciens.map(t => <option key={t.id} value={t.id}>{t.prenom} {t.nom}</option>)}
                    </select>
                    <select className="form-control" style={{ width: 200 }} value={filterClient} onChange={e => setFilterClient(e.target.value)}>
                        <option value="">Tous les clients</option>
                        {clients.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                    </select>
                    <input type="date" className="form-control" style={{ width: 180 }} value={filterDate} onChange={e => setFilterDate(e.target.value)} />
                    <button className="btn" onClick={() => { setFilterTech(''); setFilterDate(''); setFilterClient('') }}>
                        <i className="ti ti-x" /> Réinitialiser
                    </button>
                </div>
            )}

            {loading ? <Loading /> : (
                <>
                    {/* Vue technicien — ses rapports */}
                    {tab === 'mes-rapports' && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {rapports.length === 0
                                ? <Empty icon="report-off" message="Aucun rapport — rédigez votre premier rapport du jour !" />
                                : rapports.map(r => (
                                    <div key={r.id} style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderLeft: `4px solid ${r.statut === 'soumis' ? 'var(--success)' : 'var(--warning)'}`, borderRadius: 'var(--radius)', padding: '14px 16px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                            <div>
                                                <strong style={{ fontSize: 14 }}>{fmtDate(r.date_rapport)}</strong>
                                                <span style={{ marginLeft: 10, fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: r.statut === 'soumis' ? '#e8f5e9' : '#fff8e1', color: r.statut === 'soumis' ? '#2e7d32' : '#e65100' }}>
                                                    {r.statut === 'soumis' ? '✓ Soumis' : '✏ Brouillon'}
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', gap: 6 }}>
                                                {r.statut === 'brouillon' && (
                                                    <>
                                                        <button className="btn sm" onClick={() => { setSelected(r); setModal(true) }}>
                                                            <i className="ti ti-edit" /> Modifier
                                                        </button>
                                                        <button className="btn sm primary" onClick={() => soumettre(r.id)}>
                                                            <i className="ti ti-send" /> Soumettre
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.7 }}>
                                            <strong>Activités :</strong> {r.contenu}
                                        </div>
                                        {r.interventions && (
                                            <div style={{ fontSize: 13, color: 'var(--text2)', marginTop: 6 }}>
                                                <strong>Interventions :</strong> {r.interventions}
                                            </div>
                                        )}
                                        {r.problemes && (
                                            <div style={{ fontSize: 13, color: 'var(--danger)', marginTop: 6 }}>
                                                <strong>Problèmes :</strong> {r.problemes}
                                            </div>
                                        )}
                                    </div>
                                ))
                            }
                        </div>
                    )}

                    {/* Vue admin — rapport hebdo consolidé */}
                    {tab === 'hebdo' && (
                        <div>
                            <div style={{ background: 'var(--primary-light)', border: '1px solid var(--g100)', borderRadius: 'var(--radius)', padding: '10px 16px', marginBottom: 16, fontSize: 13, color: 'var(--primary)' }}>
                                <i className="ti ti-calendar-week" style={{ marginRight: 6 }} />
                                Rapports soumis cette semaine — {hebdoFiltre.length} rapport(s) de {Object.keys(parTech).length} technicien(s)
                            </div>

                            {Object.keys(parTech).length === 0
                                ? <Empty icon="report-off" message="Aucun rapport soumis cette semaine" />
                                : Object.entries(parTech).map(([nom, raps]) => (
                                    <div key={nom} className="card" style={{ marginBottom: 14 }}>
                                        <div className="card-title">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f3e5f5', color: '#6a1b9a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 12 }}>
                                                    {nom.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
                                                </div>
                                                <span>{nom}</span>
                                                <span style={{ fontSize: 12, color: 'var(--text3)' }}>— {raps.length} jour(s)</span>
                                            </div>
                                        </div>
                                        {raps.map(r => (
                                            <div key={r.id} style={{ borderTop: '1px solid var(--border)', padding: '10px 0' }}>
                                                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text3)', marginBottom: 6 }}>
                                                    {fmtDate(r.date_rapport)}
                                                </div>
                                                <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: r.interventions || r.problemes ? 4 : 0 }}>
                                                    {r.contenu}
                                                </p>
                                                {r.interventions && <p style={{ fontSize: 12, color: 'var(--text2)' }}><strong>Interventions :</strong> {r.interventions}</p>}
                                                {r.problemes && <p style={{ fontSize: 12, color: 'var(--danger)' }}><strong>Problèmes :</strong> {r.problemes}</p>}
                                            </div>
                                        ))}
                                    </div>
                                ))
                            }
                        </div>
                    )}

                    {/* Vue admin — tous les rapports */}
                    {tab === 'tous' && (
                        <div className="card" style={{ padding: 0 }}>
                            {rapports.length === 0
                                ? <Empty icon="report-off" message="Aucun rapport" />
                                : (
                                    <div className="table-wrap">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Technicien</th><th>Date</th><th>Statut</th><th>Aperçu</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rapports.map(r => (
                                                    <tr key={r.id}>
                                                        <td><strong>{r.technicien_nom || '—'}</strong></td>
                                                        <td>{fmtDate(r.date_rapport)}</td>
                                                        <td>
                                                            <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: r.statut === 'soumis' ? '#e8f5e9' : '#fff8e1', color: r.statut === 'soumis' ? '#2e7d32' : '#e65100' }}>
                                                                {r.statut === 'soumis' ? '✓ Soumis' : '✏ Brouillon'}
                                                            </span>
                                                        </td>
                                                        <td style={{ color: 'var(--text2)', fontSize: 12, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {r.contenu}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            }
                        </div>
                    )}
                </>
            )}

            {/* Modal rédaction rapport */}
            {modal && (
                <RapportModal
                    rapport={selected}
                    onClose={() => { setModal(false); setSelected(null) }}
                    onSaved={() => { setModal(false); setSelected(null); load(); toast('Rapport sauvegardé', 'success') }}
                />
            )}
        </div>
    )
}

function RapportModal({ rapport, onClose, onSaved }) {
    const { toast } = useApp()
    const [form, setForm] = useState({
        contenu: rapport?.contenu || '',
        interventions: rapport?.interventions || '',
        problemes: rapport?.problemes || '',
        date_rapport: rapport?.date_rapport || new Date().toISOString().split('T')[0],
        contact_id: rapport?.contact_id || '',
    })
    const [saving, setSaving] = useState(false)
    const [contacts, setContacts] = useState([])
    const [photos, setPhotos] = useState([])
    const f = k => e => setForm(p => ({ ...p, [k]: e.target.value }))

    useEffect(() => {
        contactsApi.list({ per_page: 200 }).then(r => setContacts(r.data || [])).catch(() => { })
    }, [])

    async function save(e) {
        e.preventDefault(); setSaving(true)
        try {
            const fd = new FormData()
            Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v) })
            photos.forEach(f => fd.append('photos[]', f))
            await fetch('/api/rapports', {
                method: 'POST',
                headers: { Authorization: `Bearer ${localStorage.getItem('hs_token')}` },
                body: fd,
            }).then(r => r.json()).then(d => { if (!d.success) throw new Error(d.message) })
            onSaved()
        } catch (err) { toast(err.message, 'error') }
        finally { setSaving(false) }
    }

    return (
        <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
            <div className="modal" style={{ maxWidth: 580 }}>
                <div className="modal-header">
                    <span className="modal-title">
                        {rapport ? 'Modifier le rapport' : 'Rapport du jour'}
                    </span>
                    <button className="btn sm icon" onClick={onClose}><i className="ti ti-x" /></button>
                </div>
                <form onSubmit={save}>
                    <div className="modal-body">
                        <FormGroup label="Date">
                            <input type="date" className="form-control" value={form.date_rapport} onChange={f('date_rapport')} />
                        </FormGroup>
                        <FormGroup label="Client concerné">
                            <select className="form-control" value={form.contact_id} onChange={f('contact_id')}>
                                <option value="">— Aucun —</option>
                                {contacts.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                            </select>
                        </FormGroup>
                        <FormGroup label="Activités réalisées" required>
                            <textarea className="form-control" rows={4} value={form.contenu} onChange={f('contenu')}
                                placeholder="Décrivez les tâches effectuées aujourd'hui…" required />
                        </FormGroup>
                        <FormGroup label="Interventions terrain">
                            <textarea className="form-control" rows={3} value={form.interventions} onChange={f('interventions')}
                                placeholder="Clients visités, installations effectuées…" />
                        </FormGroup>
                        <FormGroup label="Problèmes rencontrés">
                            <textarea className="form-control" rows={2} value={form.problemes} onChange={f('problemes')}
                                placeholder="Difficultés, blocages, points d'attention…" />
                        </FormGroup>
                        <FormGroup label="Captures d'écran / Photos">
                            <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                multiple
                                onChange={e => setPhotos([...e.target.files])}
                            />
                            {photos.length > 0 && (
                                <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                                    {photos.map((f, i) => (
                                        <img key={i} src={URL.createObjectURL(f)} alt="" style={{ width: 80, height: 60, objectFit: 'cover', borderRadius: 4, border: '1px solid var(--border)' }} />
                                    ))}
                                </div>
                            )}
                            {rapport?.photos && (
                                <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                                    {JSON.parse(rapport.photos || '[]').map((p, i) => (
                                        <img key={i} src={window.location.origin + '/api/' + p} alt="" style={{ width: 80, height: 60, objectFit: 'cover', borderRadius: 4, border: '1px solid var(--border)' }} />
                                    ))}
                                </div>
                            )}
                        </FormGroup>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn" onClick={onClose}>Annuler</button>
                        <button type="submit" className="btn primary" disabled={saving}>{saving ? '…' : 'Sauvegarder'}</button>
                    </div>
                </form>
            </div>
        </div>
    )
}